export default function isTest() {
	return process.env.NODE_ENV === "test";
}



// WEBPACK FOOTER //
// ./src/shared/util/isTest.js